import { render } from "./AwardCmt.vue?vue&type=template&id=67b13606&scoped=true"
import script from "./AwardCmt.vue?vue&type=script&lang=js"
export * from "./AwardCmt.vue?vue&type=script&lang=js"

import "./AwardCmt.vue?vue&type=style&index=0&id=67b13606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b13606"]])

export default __exports__